import { findPagePromocoes, criarPromocao, atualizarPromocao, findDescontosProgressivosAplicaveisNaVenda, 
	atualizaRelacaoVendaPromocao, validarItensDaVendaParaPromocao } from "@/api/promocao";
import { ItemDaVenda, Promocao } from "@/models";
import { PromocaoServiceAdapter } from "@/usecases/venda/adapter/PromocaoServiceAdapter";
import { AxiosRequestConfig } from "axios";
import { injectable } from "inversify-props";

@injectable()
export class PromocaoService implements PromocaoServiceAdapter{
	findPagePromocoes = async (params?: any, config?: AxiosRequestConfig) => await findPagePromocoes(params, config)
	criarPromocao = async (promocao: Promocao) => await criarPromocao(promocao)
	atualizarPromocao = async (promocao: Promocao) => await atualizarPromocao(promocao)
	findDescontosProgressivosAplicaveisNaVenda = async (lojaId: any, cpfOuCnpjCliente: string, itens: ItemDaVenda[], valorTotalLiquidoDosItens: any) => 
		await findDescontosProgressivosAplicaveisNaVenda(lojaId, cpfOuCnpjCliente, itens, valorTotalLiquidoDosItens)
	atualizaRelacaoVendaPromocao = async (params: any) => await atualizaRelacaoVendaPromocao(params)
	validarItensDaVendaParaPromocao = async(promocaoId: any, itens: ItemDaVenda[]) => await validarItensDaVendaParaPromocao(promocaoId, itens)
}